module.exports = __webpack_public_path__ + "img/bg-left-diamond-grey.0efb9ac.png";